import { createSortOption } from "@nosto/preact"

export const discountCodeText = '25% off with code: MLK25';

export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    // createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("newest", "Newest", { field: "datePublished", order: "asc" }),
    // createSortOption("oldest", "Oldest", { field: "datePublished", order: "desc" }),
    createSortOption("price", "Price, Low - High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price, High - Low", { field: "price", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[1],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: 'USD'
}

export const sizeFacetOrder = [
    "2T", "3T", "4T",
    "5", "6", "7", "8", "10", "12", "14", "16",
    "S", "S/M", "M", "L", "L/XL", "XL",
    "1SIZE",
    "3-6 Months", "6-12 Months", "12-18 Months", "18-24 Months",
    "$25.00", "$50.00", "$100.00", "$150.00", "$200.00", "$500.00",
];

export const facetTypes = [
    { 
        facetNames: ["Size"],
        type: 'boxed',
    },
    {
        facetNames: ["Color"],
        type: 'color',
    },
]

export const PROD_GROUP_TAG1_SUBSTRING = 'group-'
export const NOSTO_GRAPHQL_API_KEY = "OgFpnqwRYx3Po59CSI76b8BIcCtv0WyQa99L7d1JpctaCwtMLnRxWVojGnQVYyK5"
export const PAGINATION_WIDTH = 5;